import { render, staticRenderFns } from "./HMIconLogo.vue?vue&type=template&id=90ba3060&"
import script from "./HMIconLogo.vue?vue&type=script&lang=ts&"
export * from "./HMIconLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports